<template>
  <DragTable
    @drag-add="dragAdd"
    class="routine-table"
    v-model="dataPortions"
    group="portions"
    handle=".name-td"
    placeholder="Sin porciones"
    ref="table"
  >
    <template v-slot:header>
      <div class="flex-th table-title">
        {{ title }}
      </div>
      <div class="flex-trow flex-trow-header week-header-row">
        <div class="flex-th quantity-th">Cantidad</div>
        <div class="flex-th name-th">Grupo alimenticio</div>
      </div>
    </template>
    <template v-slot:draggable>
      <div
        v-for="(portion, index) in portions"
        :key="portion.id"
        class="flex-trow drag-row"
      >
        <div class="remove-routine" @click="removeElement(index)">
          <IconCross />
        </div>
        <div class="flex-td quantity-td editable-cell" >
          <EditableCellInput 
            v-model="portion.quantity" 
            :state="$v.dataPortions.$each[index].quantity.$invalid ? false : null "
          />
        </div>
        <div class="flex-td name-td">
          {{ portion.food_group.name }}
        </div>
      </div>
    </template>
  </DragTable>
</template>

<script>
import DragTable from "./base/DragTable";
import EditableCellInput from "../EditableCellInput";
import IconCross from "../icon/IconCross";
import { decimal, maxValue, minValue, required } from 'vuelidate/lib/validators'

export default {
  name: "MealPortionsTable",
  components: { IconCross, DragTable, EditableCellInput },
  model: {
    prop: "portions",
    event: "change"
  },
  props: {
    portions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    title: {
      type: String,
      default: "Porciones"
    }
  },
  data: function() {
    return {
      dataPortions: this.portions,
    };
  },
  validations:{
    dataPortions: {
      $each: {
        quantity: {
          required,
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99.9),
          decimalPlaces (value) {
            return value === Number(value).toFixed(1) || value === Number(value).toFixed(0)
          }
        }
      }
    }
  },
  mounted() {
    // pass
  },
  methods: {
    removeElement: function(index) {
      this.dataPortions.splice(index, 1);
    },
    dragAdd: function(index) {
      // checks if foodGroup already exists in this meal
      this.dataPortions.forEach((element, i) => {
        if (i != index) {
          if (element.food_group.id === this.dataPortions[index].food_group.id) {
            element.quantity = (Number(element.quantity) + Number(1.0)).toFixed(1)
            this.dataPortions.splice(index, 1)

          }
        } 
      });
    }
  },
  watch: {
    dataPortions: function(val) {
      this.$emit("change", val);
    }
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
$routine-table-base-color: $dark-blue;// #517a51;
$routine-table-title-bg-color: $routine-table-base-color;
$routine-table-title-color: $white;
$routine-table-header-bg-color: rgba($routine-table-base-color, 0.1);
$routine-table-header-color: $routine-table-base-color;

.routine-table {
  overflow-x: auto;
  padding: 4px;
  width: 85%;
  flex-direction: column;
}

.flex-th.table-title {
  background-color: $routine-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
  padding: 0.5rem;
}

.flex-th {
  background-color: $routine-table-header-bg-color;
  color: $routine-table-header-color;
  padding: 0.25rem;
}

.name-td,
.name-th {
  text-align: center;
  padding-left: 40px;
  flex: 1 0 27rem;
  min-width: 27rem;
}

.quantity-td,
.quantity-th {
  text-align: center;
  padding-left: 40px;
  flex: 1 0 9rem;
  min-width: 9rem;
}

.observation-th {
  padding-left: 1rem;
}

.name-td {
  cursor: move;
}

.flex-trow-header.with-week-title {
  height: unset;

  & .flex-th {
    font-weight: normal;
    font-size: $font-size-sm;
    font-style: italic;
  }
}

.drag-row.flex-trow {
  position: relative;
  min-height: $routine-row-min-height;
  min-width: fit-content;

  &:nth-child(2n) {
    background-color: rgba($dark-blue, 0.025);
  }
}

.drag-chosen .flex-td:not(.name-td) {
  opacity: 0.25;
}

.week-header-row > .flex-th,
.week-header > .flex-trow > .flex-th {
  border-bottom: 2px solid rgba($gray-900, 0.1);
}

.week-start,
.week-header > .flex-trow .flex-th:first-child,
.week-header > .flex-th {
  border-left: 2px solid rgba($gray-900, 0.1);
}

.flex-trow .remove-routine {
  display: none;
  position: absolute;
  margin: -0.5px;
  height: 100%;
  align-items: center;
  width: 2rem;
  justify-content: center;
  color: inherit;

  & svg {
    width: 1rem;
    margin-top: 0.1rem;
    opacity: 0.5;
  }

  &:after {
    content: "";
    display: block;
    background-color: currentColor;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }
}

.flex-trow:hover .remove-routine {
  display: flex;
  cursor: pointer;
}

.num-cell input {
  padding: 0;
}

.editable-cell {
  & input,
  & textarea,
  & input::placeholder,
  & textarea::placeholder {
    color: inherit;
  }
}

.with-unit {
  position: relative;

  & input {
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    opacity: 0.5;
    color: inherit;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      opacity: 1;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active,
    &:focus {
      opacity: 1;
      background-color: $active-background-color;
    }
  }
}

.routine-btnbar-group {
  position: absolute;
  right: 0.5rem;
  display: flex;
  align-items: center;

  & span {
    font-weight: normal;
    font-size: $font-size-sm;
    margin: 0 0.3rem 0;
  }

  & button {
    margin: 0 map_get($spacers, 1);
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.2rem 0.2rem 0.4rem;
    line-height: 0;
    font-weight: bold;
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.routine-table {
  & > .flex-tcol {
    flex-basis: 100%;
  }

  & .drag-content .transition-group {
    display: flex;
    flex-direction: column;
    width: auto;
  }
}
</style>